import UTILS from '../core/utils';

// Add all page load Global task below
window.addEventListener('message', function (event) {
	UTILS.setFrameHeight();  // Set fund info iframe asuming one one frame per page with funds_iframe class
});
